export enum CriteriaColor {
  Red = 'Red',
  Yellow = 'Yellow',
  Green = 'Green',
}
